export default (server) => {
  server.get('/plans', (schema) => {
    return schema.plans.all().models.map(m => m.attrs)
  })
  server.get('/plans/:id/consumption', (schema, request) => {
    const plan = schema.plans.find(request.params.id)
    return {
      plan_id: plan.attrs.id,
      ...plan.attrs.consumption
    }
  })
}
